<template>
  <pf-grid gutter>
    <template
      v-if="
        withDevelopersGrants &&
        pannello.has_whm_key &&
        (pannello.tipo_pannello === 'cPanel' ||
          pannello.tipo_pannello === 'cPanel - mail only' ||
          pannello.tipo_pannello === 'WHM' ||
          pannello.tipo_pannello === 'cPanel - dns only')
      "
    >
      <pf-grid-item md="6">
        <pf-title h="3">{{ $t('Dati di accesso') }}</pf-title>

        <pf-form component="div" style="max-width: 80ch">
          <form-group :name="$t('Username')">
            <x-input id="service-username" type="text" readonly v-model="pannello.username" />
          </form-group>

          <form-group :name="$t('Resetta la password')">
            <template #helper-text v-if="pannello.tipo_pannello !== 'cPanel - dns only'">
              {{ $t('La password modificata è allo stesso tempo quella di accesso al pannello cPanel che quella di accesso FTP') }}
            </template>
            <form-input
              id="service-password"
              v-model="password"
              name="password"
              type="new-password"
              minlength="5"
              :title="$t('Salva')"
              :new-password-label="$t('Genera nuova password')"
              @save="save"
            />
          </form-group>
        </pf-form>
      </pf-grid-item>

      <pf-grid-item md="6">
        <pf-title h="3">{{ $t('Interfaccia di gestione') }}</pf-title>

        <pf-flex direction="column" align-items="flex-start">
          <pf-button variant="control" :loading="openingPanel" @click="openPanel(pannello.id, pannello.tipo_pannello)">
            <template #icon><cpanel-icon /></template>
            {{ $t('Accedi al pannello di Controllo') }} ({{ pannello.tipo_pannello }}) <arrow-up-right-from-square-icon style="font-size: 0.75rem" />
          </pf-button>

          <pf-button
            v-if="showDnsLogin && (pannello.tipo_pannello === 'cPanel' || pannello.tipo_pannello === 'cPanel - dns only')"
            variant="control"
            :loading="openingDns"
            @click="openDns(pannello.id, pannello.tipo_pannello, 'Zone_Editor')"
            ouia-id="cpanel-dns-login-button"
          >
            <template #icon><domain-icon /></template>
            {{ $t('Gestione DNS') }} <arrow-up-right-from-square-icon style="font-size: 0.75rem" />
          </pf-button>

          <pf-button
            v-if="pannello.tipo_pannello === 'cPanel'"
            variant="control"
            :loading="openingPhpMyAdmin"
            @click="openPhpMyAdmin(pannello.id, pannello.tipo_pannello, 'Database_phpMyAdmin')"
          >
            <template #icon><database-icon /></template>
            {{ $t('Gestione database') }} (phpMyAdmin) <arrow-up-right-from-square-icon style="font-size: 0.75rem" />
          </pf-button>

          <pf-button
            v-if="pannello.tipo_pannello === 'cPanel'"
            variant="control"
            :loading="false"
            @click="openSshModal = true"
          >
            <template #icon><lock-icon /></template>
            {{ $t('Gestisci chiavi SSH') }}
          </pf-button>
          <pf-flex-item>
            {{ $t('Url pannello') }}:
            <pf-button variant="link" inline :href="cpanelUrl" target="_blank" rel="noreferer">
              {{ cpanelUrl }}
            </pf-button>
          </pf-flex-item>
        </pf-flex>
      </pf-grid-item>
    </template>

    <template v-if="pannello.tipo_pannello === 'cPanel' || pannello.tipo_pannello === 'cPanel - mail only'">
      <pf-grid-item
        v-if="(isDefined(pannello.quotaused) && isDefined(pannello.quotalimit)) || (isDefined(pannello.bwused) && isDefined(pannello.bwlimit))"
        md="6"
      >
        <pf-title h="3">{{ $t('Consumi') }}</pf-title>

        <pf-progress
          v-if="isDefined(pannello.quotaused) && isDefined(pannello.quotalimit)"
          :title="$t('Spazio')"
          :label="storageLabel(Number(pannello.quotaused), Number(pannello.quotalimit))"
          :value="(Number(pannello.quotaused) / Number(pannello.quotalimit)) * 100"
          :variant="progressVariant(Number(pannello.quotaused), Number(pannello.quotalimit))"
          class="pf-v6-u-mt-sm"
        />

        <pf-progress
          v-if="isDefined(pannello.bwused) && isDefined(pannello.bwlimit)"
          :title="$t('Traffico')"
          :label="bwLabel(Number(pannello.bwused), Number(pannello.bwlimit))"
          :value="(Number(pannello.bwused) / Number(pannello.bwlimit)) * 100"
          :variant="progressVariant(Number(pannello.bwused), Number(pannello.bwlimit))"
          class="pf-v6-u-mt-sm"
        />
      </pf-grid-item>

      <pf-grid-item md="6" class="pf-v6-c-form" v-if="pannello.traffico">
        <form-group
          :name="$t('Upgrade automatico del traffico allo sforamento del limite previsto dal piano')"
          :field-help="
            $t(
              'Attivando l\'upgrade automatico del traffico questo hosting potrà superare i limiti mensili di traffico compresi nell\'attuale piano attivo, indicati qui sopa. Il costo di questo servizio è di {0} / Tb / mese che verranno fatturati solamente in caso di superamento. Il primo mese è gratis.',
              [automaticUpgradeCost],
            )
          "
        >
          <pf-switch
            :checked="localAutoUpgradeBw"
            @update:checked="toggleAutoUpgrade"
            :value="true"
            :disabled="savingAutoUpgradeBw"
            :label="localAutoUpgradeBw ? $t('Attivo') : $t('Disattivo')"
          />
          {{ ' ' }}
          <pf-spinner v-if="savingAutoUpgradeBw" size="sm" inline />
        </form-group>
      </pf-grid-item>

      <pf-grid-item md="6" v-if="pannello.server_location">
        <pf-title h="3">{{ $t('Location') }}</pf-title>
        {{ $t('Location del server') }}: {{ pannello.server_location }}
      </pf-grid-item>

      <pf-grid-item md="6" v-if="pannello.backup_location">
        <pf-title h="3">{{ $t('Backup') }}</pf-title>
        <p>{{ $t('Location dei backup') }}: {{ pannello.backup_location }}</p>
        <p>{{ allFeatures.backup.tooltip }}</p>
        <p>{{ $t('Stato') }}: {{ $t('Attivo') }} <circle-icon color="green" /></p>
      </pf-grid-item>
    </template>
  </pf-grid>

  <pf-modal v-if="pannello.tipo_pannello === 'cPanel' && openSshModal" v-model:open="openSshModal" variant="medium" :title="$t('Chiavi SSH')">
    <template #description>
      {{ $t('Le chiavi SSH permettono di stabilire una connessione sicura al server.') }}
    </template>
    <ssh-keys :id-pannello="pannello.id" />
  </pf-modal>
</template>

<style lang="scss" scoped>
.pf-v6-l-grid.pf-m-gutter {
  --pf-v6-l-grid--m-gutter--GridGap: 3rem;
}

h3.pf-v6-c-title {
  margin-bottom: var(--pf-t--global--spacer--md);
}
</style>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import { $size } from '@/app-globals';
import { isDefined } from '@vueuse/shared';
import { type ServicePannello } from '@/resources';
import FormInput from '@common/FormInput.vue';
import SshKeys from '../components/ssh-keys.vue';
import { Resource, CpanelLoginResource, WhmLoginResource } from '@/resources';
import { getAllProductFeatures } from './product-feature.vue';
import ArrowUpRightFromSquareIcon from '@vue-patternfly/icons/arrow-up-right-from-square-icon';
import CircleIcon from '@vue-patternfly/icons/circle-icon';
import LockIcon from '@vue-patternfly/icons/lock-icon';
import DomainIcon from '@vue-patternfly/icons/domain-icon';
import CpanelIcon from '@vue-patternfly/icons/cpanel-icon';
import DatabaseIcon from '@vue-patternfly/icons/database-icon';
import { useFunctionRunningState } from '@common/use';

async function panelLogin(id: number, kind: 'cPanel' | 'cPanel - mail only' | 'cPanel - dns only' | 'WHM', app?: string) {
  if (['cPanel', 'cPanel - mail only', 'cPanel - dns only'].includes(kind)) {
    window.open(await new CpanelLoginResource(app ? { app } : undefined).get(id));
  } else {
    window.open(await new WhmLoginResource().get(id));
  }
}

const { isRunning: openingPanel, run: openPanel } = useFunctionRunningState(panelLogin, { preventMultiple: true });
const { isRunning: openingDns, run: openDns } = useFunctionRunningState(panelLogin, { preventMultiple: true });
const { isRunning: openingPhpMyAdmin, run: openPhpMyAdmin } = useFunctionRunningState(panelLogin, { preventMultiple: true });

const props = defineProps<{
  idPannello: number;
  dominio: string;
  pannello: ServicePannello;
  currency: 'EUR' | 'CHF';
  withDevelopersGrants?: boolean;
  showDnsLogin?: boolean;
}>();

const allFeatures = getAllProductFeatures();

const openSshModal = ref(false);
const password = ref('');
const localAutoUpgradeBw = ref(props.pannello.auto_upgrade_bw);

const automaticUpgradeCost = computed(() => (props.currency == 'EUR' ? '20,00 €' : '25.- CHF'));

function storageLabel(quotaUsed: number, quotaLimit: number) {
  return `${$size(quotaUsed * 1000000)} / ${$size(quotaLimit * 1000000)}`;
}

function bwLabel(bwUsed: number, bwLimit: number) {
  return `${$size(bwUsed * 1000000)} / ${bwLimit === 0 ? '∞' : $size(bwLimit * 1000000)}`;
}

function progressVariant(quota: number, limit: number) {
  if (limit === 0 || quota / limit < 0.75) {
    return 'success';
  }
  if (quota / limit < 0.95) {
    return 'warning';
  }
  return 'danger';
}

const { isRunning: savingAutoUpgradeBw, run: toggleAutoUpgrade } = useFunctionRunningState(
  async (e: boolean) => {
    if (localAutoUpgradeBw.value === e) {
      return;
    }

    localAutoUpgradeBw.value = e;
    try {
      await new Resource('services').save(props.idPannello, { auto_upgrade_bw: e });
    } catch (exc) {
      localAutoUpgradeBw.value = !exc;
    }
  },
  { preventMultiple: true },
);

async function save(value: string, name: string | undefined) {
  if (!name) {
    return;
  }

  try {
    await new Resource('services').save(props.idPannello, {
      [name]: value,
    });
  } catch (ex: any) {
    if (!ex.response || ![401, 404, 422].includes(ex.response.status)) {
      throw ex;
    }
  }
}

// URL fuori dal template: vue-tsc 3.3.13 interpreta il // delle URL nelle prop come commento (vuejs/language-tools#6240)
const cpanelUrl = computed(() => `https://${props.pannello.server_fqdn}:2083`);
</script>
